import { Component, Input } from '@angular/core';
import { StorageService } from '@manager-app/storage/service/storage.service';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { ContactType, RepresentativeContactModel, RepresentativeModel } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-representatives-new',
    templateUrl: './representatives-new.component.html',
    styleUrls: ['./representatives-new.component.css'],
    imports: [NgIf, NgFor, FormsModule, TranslocoPipe]
})
export class RepresentativesNewComponent {
  list: RepresentativeModel[] = [];
  _id;
  @Input()
  set id(val) {
    this._id = val || null;
    if (val) {
      this.getRepresentative();
    }
  }
  get id() {
    return this._id;
  }
  types = Object.keys(ContactType);
  isLoading = {
    list: false,
  };

  constructor(
    private storageService: StorageService,
    private toastr: HcToastrService,
    private tr: TranslocoService
  ) { }

  private getRepresentative() {
    this.list = [];
    this.isLoading.list = true;

    this.storageService.getSupplier(this.id).subscribe(
      result => {
        this.list = result.representatives;
        this.isLoading.list = false;
      },
      () => {
        this.isLoading.list = false;
      }
    );
  }

  private deleteItem(id: number) {
    this.storageService.deleteRepresentative(this.id, id).subscribe(
      () => {
        this.toastr.success(this.tr.translate('representatives-new.ts.deleteSuccess'));
        this.getRepresentative();
      }
    );
  }

  private deleteContact(id: number, representativeId: number) {
    this.storageService.deleteRepresentativeContact(this.id, representativeId, id).subscribe(
      () => {
        this.toastr.success(this.tr.translate('representatives-new.ts.deleteContact'));
        this.getRepresentative();
      }
    );
  }

  addContacts(index: number) {
    if (!this.list[index].contacts) {
      this.list[index].contacts = [];
    }
    const idx = this.list[index].contacts ? this.list[index].contacts.length : 0;
    this.list[index].contacts.splice(idx, 0, {} as RepresentativeContactModel);
  }

  removeContact(item: RepresentativeContactModel, index: number, a: number) {
    if (item && item.id) {
      return this.deleteContact(item.id, this.list[index].id);
    }

    this.list[index].contacts.splice(a, 1);
  }

  updateContact(item: RepresentativeContactModel, id: number) {
    if (this.id && id) {
      const obj = {...item};
      obj.value = item.value.replace(/\D+/g, '');

      let api = this.storageService.createRepresentativeContact(this.id, id, [item]);

      if (item && item.id) {
        delete obj.id;
        api = this.storageService.updateRepresentativeContact(this.id, id, item.id, obj);
      }

      api.subscribe(
        () => {
          this.toastr.success(this.tr.translate('representatives-new.ts.saveSuccess'));
          this.getRepresentative();
        },
        () => {
          this.toastr.error(this.tr.translate('representatives-new.ts.error'));
        }
      );
    }
  }

  addItem() {
    this.list.push({
      name: '',
      position: ''
    });
  }

  removeField(item: any, index: number) {
    if (item && item.id) {
      return this.deleteItem(item.id);
    }

    this.list.splice(index, 1);
  }

  updateData(item) {
    if (this.id) {
      let api = this.storageService.createRepresentative(this.id, [item]);

      if (item && item.id) {
        const obj = {
          position: item.position,
          name: item.name
        };
        api = this.storageService.updateRepresentative(this.id, item.id, obj);
      }

      api.subscribe(
        result => {
          this.toastr.success(this.tr.translate('representatives-new.ts.success'));
          this.getRepresentative();
        },
        result => {
          this.toastr.error(this.tr.translate('representatives-new.ts.errorReset'));
        }
      );
    }
  }
}
